import React, { useState } from 'react';
import BottomNavigation from '../components/BottomNavigation';
import './NavigationDemo.css';

const NavigationDemo = () => {
  const [activeTab, setActiveTab] = useState('home');

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return (
          <div className="demo-content">
            <h2>🏠 Página Inicial</h2>
            <p>Bem-vindo à página inicial do sistema.</p>
            <div className="demo-card">
              <h3>Resumo do Sistema</h3>
              <p>Aqui você encontra as principais informações e atalhos para as funcionalidades mais utilizadas.</p>
            </div>
          </div>
        );
      case 'financial':
        return (
          <div className="demo-content">
            <h2>💰 Financeiro</h2>
            <p>Gestão financeira da igreja.</p>
            <div className="demo-card">
              <h3>Controle de Dízimos e Ofertas</h3>
              <p>Acompanhe as entradas e saídas financeiras da igreja.</p>
            </div>
          </div>
        );
      case 'secretary':
        return (
          <div className="demo-content">
            <h2>👥 Secretaria</h2>
            <p>Gestão de membros e atividades.</p>
            <div className="demo-card">
              <h3>Cadastro de Membros</h3>
              <p>Gerencie informações dos membros da igreja.</p>
            </div>
          </div>
        );
      case 'admin':
        return (
          <div className="demo-content">
            <h2>⚙️ Administração</h2>
            <p>Configurações e administração do sistema.</p>
            <div className="demo-card">
              <h3>Configurações Gerais</h3>
              <p>Ajuste as configurações do sistema e gerencie usuários.</p>
            </div>
          </div>
        );
      case 'profile':
        return (
          <div className="demo-content">
            <h2>👤 Perfil</h2>
            <p>Informações do usuário logado.</p>
            <div className="demo-card">
              <h3>Meu Perfil</h3>
              <p>Visualize e edite suas informações pessoais.</p>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="navigation-demo">
      <div className="demo-header">
        <h1>Demo - Barra de Navegação Inferior</h1>
        <p>Design minimalista com fundo branco arredondado e sombras suaves</p>
      </div>
      
      <div className="demo-main">
        {renderContent()}
      </div>

      <div className="demo-info">
        <div className="info-card">
          <h3>Características do Design:</h3>
          <ul>
            <li>✨ Fundo retangular arredondado branco</li>
            <li>🌟 Sombras suaves e elegantes</li>
            <li>🎯 5 ícones com contornos uniformes</li>
            <li>🔵 Destaque azul para item ativo</li>
            <li>📱 Design responsivo e moderno</li>
            <li>🎨 Interface limpa e profissional</li>
          </ul>
        </div>
      </div>

      <BottomNavigation 
        activeTab={activeTab} 
        onTabChange={setActiveTab} 
      />
    </div>
  );
};

export default NavigationDemo;